import { render, staticRenderFns } from "./shelf-list.vue?vue&type=template&id=352521f4&scoped=true&"
import script from "./shelf-list.vue?vue&type=script&lang=ts&"
export * from "./shelf-list.vue?vue&type=script&lang=ts&"
import style0 from "./shelf-list.vue?vue&type=style&index=0&id=352521f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352521f4",
  null
  
)

export default component.exports